import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Comments from "work/proposals/comments/_view/comments";
import CommentThread from "work/proposals/comments/threads/comment-thread";
import Proposal from "work/proposals/proposal";
import ProposalField, { HumanReadableProposalFieldName } from "work/proposals/proposal-fields/proposal-field";

const Drawer = styled(MuiDrawer)(() => ({
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    marginTop: '64px',
    width: '400px',
    boxSizing: 'border-box',
  },
}));
const CommentsPanel = styled(Drawer, { shouldForwardProp: (prop) => prop !== "closeAfterTransition" })(() => ({
}));
const CommentsPanelContainer = styled("div")(() => ({
  flex: 1,
  height: "100%",
}));
const CommentsPanelContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  padding: theme.spacing(2),
  width: "400px",
}));
const TitleBar = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  paddingBottom: theme.spacing(1),
}));

type CommentsDrawerProps = {
  proposal: Proposal | null | undefined;
  commentThreads: CommentThread[] | undefined;
  currentCommentField: ProposalField | undefined;
  activeReviewField: ProposalField | undefined;
  isOpen: boolean;
  isSaving: boolean;
  readOnly?: boolean;
  showMarkAllRead?: boolean;
  title?: string;
  onOpen: () => void;
  onClose: () => void;
};

export default function CommentsDrawer(props: Readonly<CommentsDrawerProps>) {
  const {
    proposal,
    commentThreads,
    currentCommentField,
    isOpen,
    isSaving,
    readOnly = false,
    showMarkAllRead = true,
    title,
    onClose
  } = props;

  function getTitle(): string {
    if (title) return `${title} Comments`;
    return `${HumanReadableProposalFieldName[currentCommentField?.name ?? ProposalField.General.name]} Comments`;
  }

  return (
    <CommentsPanel open={isOpen} anchor="right" variant="persistent" closeAfterTransition={false}>
      <CommentsPanelContainer>
        <CommentsPanelContent>
          <TitleBar>
            <Typography variant="h5">{getTitle()}</Typography>
            <Tooltip title="Minimize comments panel">
              <IconButton size="medium" onClick={onClose}>
                <KeyboardTabIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </TitleBar>
          {proposal?.id && (
            <Comments
              proposal={proposal}
              field={currentCommentField ?? ProposalField.General}
              commentThreads={commentThreads ?? []}
              isSaving={isSaving}
              readOnly={readOnly}
              showMarkAllRead={showMarkAllRead}
            />
          )}
        </CommentsPanelContent>
      </CommentsPanelContainer>
    </CommentsPanel>
  );
}
